import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';

export type SnackbarType = 'success' | 'warning' | 'error' | 'info';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  constructor(private snackBar: MatSnackBar) {}

  open(
    message: string,
    type: SnackbarType = 'info',
    action: string = 'Cerrar',
    config: MatSnackBarConfig = {},
  ) {
    const defaultConfig: MatSnackBarConfig = {
      duration: type === 'error' ? 4500 : 3200,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: [`snackbar-${type}`],
    };

    return this.snackBar.open(message, action, {
      ...defaultConfig,
      ...config,
      panelClass: this.mergePanelClass(
        defaultConfig.panelClass,
        config.panelClass,
      ),
    });
  }

  success(
    message: string,
    config: MatSnackBarConfig = {},
    action: string = 'Cerrar',
  ) {
    return this.open(message, 'success', action, config);
  }

  warning(
    message: string,
    config: MatSnackBarConfig = {},
    action: string = 'Cerrar',
  ) {
    return this.open(message, 'warning', action, config);
  }

  error(
    message: string,
    config: MatSnackBarConfig = {},
    action: string = 'Cerrar',
  ) {
    return this.open(message, 'error', action, config);
  }

  info(
    message: string,
    config: MatSnackBarConfig = {},
    action: string = 'Cerrar',
  ) {
    return this.open(message, 'info', action, config);
  }

  private mergePanelClass(
    base: string | string[] | undefined,
    extra: string | string[] | undefined,
  ): string[] {
    return [...this.toArray(base), ...this.toArray(extra)];
  }

  private toArray(value: string | string[] | undefined): string[] {
    if (!value) {
      return [];
    }

    return Array.isArray(value) ? value : [value];
  }
}
